import dayjs from "dayjs";
import jwt_decode, { JwtPayload } from "jwt-decode";

interface JwtPayloadPCP extends JwtPayload {
  type?: string;
  user_id: string;
  user_username: string;
  user_role: string;
}

/** Client-side JWT decoding/validation — does not verify the signature (that's the backend's job), only reads and sanity-checks the payload. */
export class JwtManage {
  /** Decodes a JWT's payload. @returns `null` if the token is malformed. */
  public static decode(token: string): JwtPayloadPCP | null {
    try {
      return jwt_decode(token);
    } catch (error) {
      return null;
    }
  }
  /** Whether the token decodes, isn't expired, and has the expected `type: "timeline"` claim. */
  public static isValid(token: string): boolean {
    const decode = this.decode(token);
    if (
      decode &&
      decode.exp &&
      decode.exp > dayjs().unix() &&
      decode &&
      decode.type &&
      decode.type === "timeline"
    ) {
      return true;
    }
    return false;
  }
}
